import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    // Set dark mode as default on document
    document.documentElement.classList.add('dark');

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-background text-white min-h-screen selection:bg-primary/30 overflow-x-hidden">
      <AnimatePresence mode="wait">
        {isLoading ? (
          <LoadingScreen key="loading" />
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            {/* Background Blobs for depth */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
              <div className="blob blob-primary" />
              <div className="blob blob-accent" />
            </div>

            <Header />
            
            <main>
              <Hero />
              <About />
              <Services />
              <Projects />
              <Contact />
            </main>
            
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;

